import React, {
  useState,
  useEffect,
  useCallback,
  useLayoutEffect,
} from "react";
import MapScreen from "assets/images/map-section.png";
import GraphScreen from "assets/images/graph-section.png";
import SettingsIcon from "@mui/icons-material/Settings";
import { getFeatureSetOption, getFeaturesList } from "../../../constant";
import CarIcon from "assets/svgIcons/CarIcon";
import PrintPinSheetImage from "assets/svgIcons/AdminDashboard/PrintPinSheetImage";
import ChangePicLocationImage from "assets/svgIcons/AdminDashboard/ChangePicLocationImage";
import PinPlacementManagerImage from "assets/svgIcons/AdminDashboard/PinPlacementManagerImage";
import CameraIcon from "assets/svgIcons/CameraIcon";
import Welcome from "pages/AdminDashboard/LeaderBoard/WelcomeScreen";
import { CircleBtn, ModalHeader, PopUpContainer } from "assets/css/globle";
import ModalCloseIcon from "assets/svgIcons/ModalCloseIcon";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import moment from "moment";
import {
  Header,
  BodyWrapper,
  TopRow,
  TopBox,
  CampaignAdsSlider,
  PaceFleetChartSection,
  SettingContainer,
  FilterContainer,
  ModalBody,
  TodayPinPositionModalBody,
} from "pages/AdminDashboard/AdminDashboardStyled";
import CloseIcon from "assets/svgIcons/CloseIcon";
import { useNavigate } from "react-router-dom";
import { useHookstate } from "@hookstate/core";
import {
  SIDENAV_GLOBAL_STATE,
  GlobalCourseIdState,
  MAP_GLOBAL_STATES,
  SITEID_GLOBAL_STATE,
  PINS_GLOBAL_STATE,
  FLEET_GLOBAL_STATES,
  LIST_BY_GLOBAL_STATES,
  COMMON_COMPONENTS_STATES,
  ADS_GLOBAL_STATE,
} from "globalStore/globalStore";
import FleetRotation from "pages/AdminDashboard/LeaderBoard/FleetRotation/fleetRotation";
import RoundsCompleted from "pages/AdminDashboard/LeaderBoard/RoundsCompleted/roundsCompleted";
import TodaysRound from "pages/AdminDashboard/LeaderBoard/TodaysRound/todaysRound";
import CarMovement from "pages/AdminDashboard/LeaderBoard/CarMovement/carMovement";
import CarSelection from "pages/AdminDashboard/LeaderBoard/Car Selection";
import CarSelectionIcon from "assets/svgIcons/AdminDashboard/Setting/CarSelection";
import BatteryNotificationIcon from "assets/svgIcons/AdminDashboard/Setting/BatteryNotification";
import ServiceNotificationIcon from "assets/svgIcons/AdminDashboard/Setting/ServiceNotificationIcon";
import CarMovementIcon from "assets/svgIcons/AdminDashboard/Setting/CarMovementIcon";
import GapsFlowIcon from "assets/svgIcons/AdminDashboard/Setting/GapsFlowIcon";
import CartPathSettingIcon from "assets/svgIcons/AdminDashboard/Setting/CartPathIcon";
import ActionZoneIcon from "assets/svgIcons/AdminDashboard/Setting/ActionZoneIcon";
import TodayCampaignIcon from "assets/svgIcons/AdminDashboard/Setting/TodayCampaignAdsIcon";
import { CarBehindPace } from "pages/AdminDashboard/LeaderBoard/CarBehindPace/CarBehindPace";
import { ActionZoneInfraction } from "pages/AdminDashboard/LeaderBoard/ActionZoneInfraction/ActionZoneInfraction";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import SelectArrow from "assets/svgIcons/SelectArrowIcon";
import { useDispatch, useSelector } from "react-redux";
import { PaceReports } from "pages/AdminDashboard/LeaderBoard/PaceReports";
import { AmpHrReport } from "pages/AdminDashboard/LeaderBoard/AmpHrReports";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import CardMedia from "@mui/material/CardMedia";
import Card from "@mui/material/Card";
import { CampaignAds } from "pages/AdminDashboard/LeaderBoard/CampaignAds";
import FleetReadiness from "pages/AdminDashboard/LeaderBoard/FleetReadiness/fleetReadiness";
import FleetUsageReports from "pages/AdminDashboard/LeaderBoard/FleetUsageReport/fleetUsageReports";
import PaceOfPlay from "pages/AdminDashboard/LeaderBoard/PaceOfPlay/paceOfPlay";
import DashboardPace from "pages/AdminDashboard/LeaderBoard/DashboardPace";
import TodayCartPathRule from "pages/AdminDashboard/LeaderBoard/TodaysCartPathRule";
import CarRoundStatus from "pages/AdminDashboard/LeaderBoard/CarRoundStatus";
import BatteryNotification from "pages/AdminDashboard/LeaderBoard/BatteryNotification";
import { PinPosition } from "./Pins";
import { setAppDataReduxStateAction } from "redux/reduxToolkitServices/_commonReducers/persistedLocalStorageReducer";
import { API_STATUSES } from "redux/_helpers/statuses";
import { Loader } from "commonComponents/Loader/Loader";
import { Responsive, WidthProvider } from "react-grid-layout";
import {
  setPinsEditModeReduxStateAction,
  getDashboardFeatureSetStateAction,
  getDashboardFeatureSetStatusAction,
} from "redux/reduxToolkitServices/_commonReducers/commonReducers";
import "../../../../node_modules/react-grid-layout/css/styles.css";
import "../../../../node_modules/react-resizable/css/styles.css";
import { uuid } from "../../../_helperFunctions/uuid";
import _ from "lodash";
import { useTranslation } from "react-i18next";
const ResponsiveGridLayout = WidthProvider(Responsive);

const layout = [
  { i: "fleet-car", x: 0, y: 0, w: 1, h: 1 },
  { i: "car-behind", x: 1, y: 0, w: 1, h: 1 },
  { i: "today-pin", x: 2, y: 0, w: 1, h: 1 },
  { i: "round-completed", x: 3, y: 0, w: 1, h: 1 },
  { i: "today-round", x: 4, y: 0, w: 1, h: 1 },
  // { i: "chat-cam", x: 5, y: 0, w: 1, h: 1 },
  // { i: "ghin", x: 0, y: 1, w: 1, h: 1 },
  { i: "pace-report", x: 5, y: 0, w: 1, h: 1 },
  { i: "amp-hr", x: 0, y: 1, w: 1, h: 1 },
  { i: "dash-pace", x: 1, y: 1, w: 1, h: 1 },
  { i: "readiness", x: 2, y: 1, w: 1, h: 1 },
  { i: "car-movement", x: 3, y: 1, w: 1, h: 1 },
];

const middleLayout = [
  { i: "car-round-status", x: 0, y: 2, w: 1, h: 1 },
  { i: "welcome", x: 1, y: 2, w: 1, h: 1 },
  { i: "map-section", x: 2, y: 2, w: 1, h: 1 },
  { i: "weather-info", x: 3, y: 2, w: 1, h: 1 },
  { i: "car-selection", x: 4, y: 2, w: 1, h: 1 },
  { i: "cart-path-rule", x: 5, y: 2, w: 1, h: 1 },
  { i: "battery-notification-section", x: 0, y: 3, w: 1, h: 1 },
  { i: "action-zone-infraction", x: 1, y: 3, w: 1, h: 1 },
  // { i: "today-campaign", x: 1, y: 3, w: 4, h: 3 },
];

export const LeaderBoard = () => {
  const { resetGlobalCourseId } =
    useHookstate(GlobalCourseIdState);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { subNavDataState, sideDrawerActiveTabState } =
    useHookstate(SIDENAV_GLOBAL_STATE);
  const { globalCourseId, setCourseId } = useHookstate(GlobalCourseIdState);
  const { roundStateGlobal, holeStateGlobal } =
    useHookstate(FLEET_GLOBAL_STATES);
  const { siteId, hideSubNav } = useHookstate(SITEID_GLOBAL_STATE);
  const {
    carBehindPaceData,
    siteSettingsData,
    getDashboardFeatureSetState,
    getDashboardFeatureSetStatus,
    getUserRole,
    siteLocationsData,
  } = useSelector((state) => state.commonReducers) || [];
  const dispatch = useDispatch();
  const { mapSideNavTabState, callSiteSelection } =
    useHookstate(MAP_GLOBAL_STATES);
  const { localSiteTimeState } = useHookstate(COMMON_COMPONENTS_STATES);
  const [isShown, setIsShown] = useState(false);
  const [FleetRoationCard, setFleetRoationCard] = useState(true);
  const [siteIdData, setsiteIdData] = useState();
  const [FleetUsageReportCard, setFleetUsageReportCard] = useState(true);
  const [FleetReadinessCard, setFleetReadinessCard] = useState(true);
  const [PacePlayReportCard, setPacePlayReportCard] = useState(true);
  const [ChatCamCard, setChatCamCard] = useState(true);
  const [UpcomingEventCard, setUpcomingEventCard] = useState(true);
  const [ScoreCardPostingCard, setScoreCardPostingCard] = useState(true);
  const [SurveyResultsCard, setSurveyResultsCard] = useState(true);
  const [GhinCard, setGhinCard] = useState(true);
  const [WeatherCard, setWeatherCard] = useState(true);
  const [FBSalesProductCard, setFBSalesProductCard] = useState(true);
  const [FBSalesTotalCard, setFBSalesTotalCard] = useState(true);
  const [WelcomeCard, setWelcomeCard] = useState(true);
  const [BatteryNotificationCard, setBatteryNotificationCard] = useState(true);
  const [CarSelectionCard, setCarSelectionCard] = useState(true);
  const [ServiceNotificationCard, setServiceNotificationCard] = useState(true);
  const [TodayCartPathCard, setTodayCartPathCard] = useState(true);
  const [ActionZoneCard, setActionZoneCard] = useState(true);
  const [FleetLockDownCard, setFleetLockDownCard] = useState(true);
  const [TodayCampaignAdsCard, setTodayCampaignAdsCard] = useState(true);
  const [TodayPinPositionCard, setTodayPinPositionCard] = useState(true);
  const [CarMovementCard, setCarMovementCard] = useState(true);
  const [CarsBehindPaceCard, setCarsBehindPaceCard] = useState(true);
  const [GapsFlowCard, setGapsFlowCard] = useState(true);
  const [PaceFastSlowestCard, setPaceFastSlowestCard] = useState(true);
  const [RoundCompletedCard, setRoundCompletedCard] = useState(true);
  const [TodayRoundsCard, setTodayRoundsCard] = useState(true);
  const [CarRoundStatusCard, setCarRoundStatusCard] = useState(true);
  const [paceReportCard, setPaceReportCard] = useState(true);
  const [mapCard, setMapCard] = useState(true);
  const [ampHrCard, setAmpHrCard] = useState(true);
  const [open, setOpen] = React.useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [dashDragState, setDragState] = useState(false);
  const [openAlertModal, setOpenAlertModal] = useState(false);
  const [openCarPathModal, setOpenCarPathModal] = useState(false);
  const [openGeofenceModal, setOpenGeofenceModal] = useState(false);
  const [courseList, setCourseList] = React.useState([]);
  const [currentDate, setCurrentDate] = useState("");
  const [layoutPayload, setLayoutPayload] = useState([]);
  const [middlelayoutPayload, setMiddleLayoutPayload] = useState([]);
  const [reloadDashState, setReloadDashState] = useState(false);
  const [detectSaveChanges, setDetectSaveChanges] = useState(false);
  const [saveModalState, setSaveModalState] = useState(false);
  const [triggerReload, setTriggerReload] = useState(false);
  const { listBy, showFilterServices } = useHookstate(LIST_BY_GLOBAL_STATES);
  const { alertMsg, redirectState, nextTabIndex, nextStageName } =
    useHookstate(ADS_GLOBAL_STATE);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 900,
    bgcolor: "background.paper",
    boxShadow: 24,
    width: "100%",
    background: "#FFFFFF",
    boxShadow: "0px 14px 100px 30px rgba(0, 0, 0, 0.3)",
    borderRadius: "20px",
    outline: "none",
  };
  const style1 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 444,
    bgcolor: "background.paper",
    boxShadow: 24,
    width: "100%",
    background: "#FFFFFF",
    boxShadow: "0px 14px 100px 30px rgba(0, 0, 0, 0.3)",
    borderRadius: "4px",
    outline: "none",
  };

  const handleModalOpen = () => setOpenModal(true);
  const handleModalClose = () => setOpenModal(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleAlertModalOpen = () => setOpenAlertModal(true);
  const handleAlertModalClose = () => setOpenAlertModal(false);
  const handleCarPathModalOpen = () => setOpenCarPathModal(true);
  const handleCarPathModalClose = () => setOpenCarPathModal(false);
  const handleGeofenceModalOpen = () => setOpenGeofenceModal(true);
  const handleGeofenceModalClose = () => setOpenGeofenceModal(false);

  const showData = [
    {
      id: 0,
      comp: <FleetRotation />,
      renderFunction: "cars",
      classname: "fleet-car-rotation",
      condition: FleetRoationCard,
      compKey: "fleet-car",
    },
    {
      id: 1,
      comp: <CarBehindPace />,
      renderFunction: handleOpen,
      classname: "",
      condition: CarsBehindPaceCard,
      compKey: "car-behind",
    },
    {
      id: 2,
      comp: <PinPosition />,
      renderFunction: "pins",
      classname: "",
      condition: TodayPinPositionCard,
      compKey: "today-pin",
    },
    {
      id: 3,
      comp: <RoundsCompleted />,
      renderFunction: "roundsCompleted",
      classname: "fleet-car-rotation",
      condition: RoundCompletedCard,
      compKey: "round-completed",
    },
    {
      id: 4,
      comp: <TodaysRound />,
      renderFunction: "",
      classname: "",
      condition: TodayRoundsCard,
      compKey: "today-round",
    },
    {
      id: 7,
      comp: <PaceReports />,
      renderFunction: "pacereports",
      classname: "",
      condition: paceReportCard,
      compKey: "pace-report",
    },
    {
      id: 8,
      comp: <AmpHrReport />,
      renderFunction: "ampreports",
      classname: "",
      condition: ampHrCard,
      compKey: "amp-hr",
    },
    {
      id: 9,
      comp: <DashboardPace />,
      renderFunction: "dashPace",
      classname: "",
      condition: PaceFastSlowestCard,
      compKey: "dash-pace",
    },
    {
      id: 10,
      comp: <FleetReadiness />,
      renderFunction: "",
      classname: "",
      condition: FleetReadinessCard,
      compKey: "readiness",
    },
    {
      id: 11,
      comp: <CarMovement />,
      renderFunction: "cars",
      classname: "",
      condition: CarMovementCard,
      compKey: "car-movement",
    },
  ];

  const showMiddleLayout = [
    {
      id: 12,
      comp: <CarRoundStatus />,
      renderFunction: "pre-round",
      classname: "",
      condition: CarRoundStatusCard,
      compKey: "car-round-status",
    },
    {
      id: 13,
      comp: <Welcome />,
      renderFunction: "welcome",
      classname: "",
      condition: WelcomeCard,
      compKey: "welcome",
    },
    // {
    //   id: 15,
    //   comp: <MapCard />,
    //   renderFunction: "map",
    //   classname: "",
    //   condition: mapCard,
    //   compKey: "map-section",
    // },
    {
      id: 16,
      comp: <CarSelection />,
      renderFunction: "",
      classname: "",
      condition: CarSelectionCard,
      compKey: "car-selection",
    },
    {
      id: 17,
      comp: <TodayCartPathRule />,
      renderFunction: "car-path", // need to add car path string
      classname: "",
      condition: TodayCartPathCard,
      compKey: "cart-path-rule",
    },
    {
      id: 18,
      comp: <BatteryNotification />,
      renderFunction: "battery-notification",
      classname: "",
      condition: BatteryNotificationCard,
      compKey: "battery-notification-section",
    },
    {
      id: 19,
      comp: <ActionZoneInfraction />,
      renderFunction: "",
      classname: "",
      condition: ActionZoneCard,
      compKey: "action-zone-infraction",
    },
  ];
  useEffect(() => {
    if (siteLocationsData?.length === 1 && localStorage.getItem("dashCourseId") === null) {
      localStorage.setItem("dashCourseId", resetGlobalCourseId.get())
    }
  }, [siteLocationsData])
  useEffect(() => {
    if (siteId.get() !== null) {
      dispatch(COMMON_SERVICES.getDashboardFeatureSetServices()).then(() => {
        setDetectSaveChanges(false);
      });
    }

    return () => {
      dispatch(getDashboardFeatureSetStateAction({}));
      dispatch(getDashboardFeatureSetStatusAction(API_STATUSES.IDLE));
    };
  }, [siteId.get()]);

  useEffect(() => {
    if (
      siteId.get() !== null &&
      siteSettingsData &&
      Object.keys(siteSettingsData).length > 0
    ) {
      setCurrentDate(
        moment(new Date())
          .utc()
          .utcOffset(-siteSettingsData?.TimeZoneOffset)
          .format("dddd MMMM DD, YYYY")
      );
      setCourseList(siteSettingsData);
    }
  }, [siteId.get(), siteSettingsData]);

  useEffect(() => {
    if (
      getDashboardFeatureSetState &&
      Object.keys(getDashboardFeatureSetState).length !== 0 &&
      getDashboardFeatureSetState?.DashboardFeatures !== null &&
      getDashboardFeatureSetState?.DashboardLayout !== null
    ) {
      handleTileToggle();
    }
  }, [getDashboardFeatureSetState]);

  useEffect(() => {
    if (reloadDashState) {
      let timeout = setTimeout(() => {
        setTriggerReload(true);
      }, 3000);

      return () => clearTimeout(timeout);
    }
  }, [reloadDashState]);

  useLayoutEffect(() => {
    if (triggerReload) {
      handlerSaveLayout();
    }
  }, [triggerReload]);

  useEffect(() => {
    if (
      getDashboardFeatureSetStatus === API_STATUSES.SUCCESS &&
      siteId.get() !== null &&
      siteSettingsData &&
      Object.keys(siteSettingsData).length > 0
    ) {
      const lastQueryDate = moment(new Date())
        .utc()
        .utcOffset(-siteSettingsData?.TimeZoneOffset)
        .format("YYYY-MM-DD");

      dispatch(
        COMMON_SERVICES.getCarBehindPaceDataServices(
          siteId.get(),
          lastQueryDate,
          localStorage.getItem("dashCourseId")
        )
      );
    }
  }, [
    getDashboardFeatureSetStatus,
    siteId.get(),
    localStorage.getItem("dashCourseId"),
    siteSettingsData,
  ]);

  function handleTileToggle() {
    if (
      getDashboardFeatureSetState &&
      getDashboardFeatureSetState?.DashboardFeatures !== null &&
      Object.keys(getDashboardFeatureSetState).length !== 0 &&
      Object.keys(getDashboardFeatureSetState?.DashboardFeatures).length !== 0
    ) {
      let checkValue = JSON.parse(
        getDashboardFeatureSetState?.DashboardFeatures
      );
      setFleetRoationCard(checkValue?.fleetUtilization);
      setCarsBehindPaceCard(checkValue?.carBehind);
      setTodayPinPositionCard(checkValue?.todayPin);
      setRoundCompletedCard(checkValue?.roundCompleted);
      setTodayRoundsCard(checkValue?.todayRound);
      setChatCamCard(checkValue?.chatCam);
      setGhinCard(checkValue?.ghin);
      setPaceReportCard(checkValue?.paceReport);
      setAmpHrCard(checkValue?.ampHr);
      setPaceFastSlowestCard(checkValue?.dashPace);
      setFleetReadinessCard(checkValue?.readiness);
      setCarMovementCard(checkValue?.carMovement);
      setCarRoundStatusCard(checkValue?.carRoundStatus);
      setWelcomeCard(checkValue?.welcome);
      setWeatherCard(checkValue?.welcomeInfo);
      setMapCard(checkValue?.map);
      setCarSelectionCard(checkValue?.carSelection);
      setTodayCartPathCard(checkValue?.carPath);
      setBatteryNotificationCard(checkValue?.batteryNotification);
      setActionZoneCard(checkValue?.actionzoneInfraction);
      setFleetUsageReportCard(checkValue?.fleetUsageReport);
      setPacePlayReportCard(checkValue?.paceOfPlay);
      setTodayCampaignAdsCard(checkValue?.todayCampaign);
    }
  }

  const handleLayoutChange = useCallback(
    (newLayout) => {
      let tempNewLayout = JSON.parse(JSON.stringify(newLayout));

      let yExtraValue = tempNewLayout.filter((el) => {
        return el.y !== 0 && el.y !== 1;
      });

      let correctValues = tempNewLayout.filter((el) => {
        return el.y === 0 || el.y === 1;
      });

      if (yExtraValue.length > 0) {
        let xAtYzero = tempNewLayout.filter((el) => {
          return el.y === 0;
        });

        let xAtYone = tempNewLayout.filter((el) => {
          return el.y === 1;
        });

        let xCountYzero = xAtYzero.length;
        let xCountYone = xAtYone.length;

        yExtraValue.forEach((item) => {
          if (xCountYzero < 6) {
            item.x = xCountYzero;
            item.y = 0;
            xCountYzero++;
          } else if (xCountYone < 6) {
            item.x = xCountYone;
            item.y = 1;
            xCountYone++;
          }
          correctValues.push(item);
        });
      }
      setLayoutPayload(correctValues);
    },
    [layoutPayload]
  );

  const handleMiddleLayoutChange = useCallback(
    (newLayout) => {
      let tempNewLayout = JSON.parse(JSON.stringify(newLayout));

      let yExtraValue = tempNewLayout.filter((el) => {
        return el.y !== 0 && el.y !== 1;
      });

      let correctValues = tempNewLayout.filter((el) => {
        return el.y === 0 || el.y === 1;
      });

      if (yExtraValue.length > 0) {
        let xAtYzero = tempNewLayout.filter((el) => {
          return el.y === 0;
        });

        let xAtYone = tempNewLayout.filter((el) => {
          return el.y === 1;
        });

        let xCountYzero = xAtYzero.length;
        let xCountYone = xAtYone.length;

        yExtraValue.forEach((item) => {
          if (xCountYzero < 4) {
            item.x = xCountYzero;
            item.y = 0;
            xCountYzero++;
          } else if (xCountYone < 4) {
            item.x = xCountYone;
            item.y = 1;
            xCountYone++;
          }
          correctValues.push(item);
        });
      }

      setMiddleLayoutPayload(correctValues);
    },
    [middlelayoutPayload]
  );

  useEffect(() => {
    if (detectSaveChanges) {
      redirectState.set(true);
    } else {
      redirectState.set(false);
    }
  }, [detectSaveChanges]);

  function handleDiscardChanges() {
    redirectState.set(false);
    alertMsg.set(false);
    if (saveModalState) {
      dispatch(COMMON_SERVICES.getDashboardFeatureSetServices()).then(() => {
        setIsShown(false);
        setDetectSaveChanges(false);
      });
      setSaveModalState(false);
    } else {
      setIsShown(false);
      hideSubNav.set(true);
      if (nextStageName.get() === "siteSelection") {
        callSiteSelection.set(true);
        return;
      }
      navigate(`/${nextStageName.get().toLowerCase()}`);
      let activeTab = nextTabIndex.get();
      let activeName = nextStageName.get();
      sideDrawerActiveTabState.set(activeTab);
      subNavDataState.set(activeName);

      localStorage.setItem("sideDrawerActiveTabState", nextTabIndex.get());

      localStorage.setItem("subNavState", "true");
      localStorage.setItem("subNavDataState", nextStageName.get());
    }
  }

  const handleClick = (event) => {
    if (detectSaveChanges) {
      alertMsg.set(true);
      setSaveModalState(true);
    } else {
      setIsShown((current) => !current);
    }
  };
  const handleCourseName = (e) => {
    setsiteIdData(e.target.value);
    globalCourseId.set(e.target.value);
    setCourseId.set(e.target.value);
    localStorage.setItem("dashCourseId", e.target.value);
    dispatch(
      setAppDataReduxStateAction({
        value: e.target.value,
        parameterDetector: "coursenumber",
      })
    );
  };

  const modal = () => {
    return (
      <Modal
        open={openModal}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <ModalHeader>
            <h2>{t("Todays_Pin_Position")}</h2>
            <ModalCloseIcon onClick={handleModalClose} />
          </ModalHeader>
          <TodayPinPositionModalBody>
            <TopBox onClick={() => redirectToPage("print")}>
              <div className="header">
                <CarIcon width={25} height={20} />
                <p className="green-border">{t("Print_Pin_Sheet")}</p>
              </div>
              <div className="box-body">
                <PrintPinSheetImage />
              </div>
            </TopBox>
            <TopBox onClick={() => redirectToPage("location")}>
              <div className="header">
                <CarIcon width={25} height={20} />
                <p className="green-border"> {t("Change_Pin_Location")}</p>
              </div>
              <div className="box-body">
                <ChangePicLocationImage />
              </div>
            </TopBox>
            <TopBox onClick={() => redirectToPage("placement")}>
              <div className="header">
                <CarIcon width={25} height={20} />
                <p className="green-border">{t("Pin_placement")}</p>
              </div>
              <div className="box-body">
                <PinPlacementManagerImage />
              </div>
            </TopBox>
          </TodayPinPositionModalBody>
        </Box>
      </Modal>
    );
  };

  function carBehindModal() {
    return (
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <ModalHeader>
            <h2>{t("Cars_Behind_Pace")}</h2>
            <ModalCloseIcon onClick={handleClose} />
          </ModalHeader>
          <ModalBody>
            <div className="data-container">
              {carList() && carList().length !== 0 ? (
                carList().map((el) => {
                  return (
                    <React.Fragment key={uuid()}>
                      <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                      >
                        {" "}
                        Car {el?.carNum}
                      </Typography>
                      -
                      <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                      >
                        {" "}
                        {el?.result}
                      </Typography>
                    </React.Fragment>
                  );
                })
              ) : (
                <>{t("No_Cars_Are_Behind_Pace")}</>
              )}
            </div>
            <div className="image-container">
              {
                <>
                  <p>{t("Map/Cars")}</p>
                  <Card
                    sx={{
                      maxWidth: 281,
                      cursor: "pointer",
                      borderRadius: "10px",
                      overflow: "hidden",
                      marginBottom: "19px",
                    }}
                    onClick={() => redirectToPage("map")}
                  >
                    <CardMedia
                      component="img"
                      height="206"
                      image={MapScreen}
                      alt="green iguana"
                    />
                  </Card>
                  <p>{t("Live_Pace_Tracking")}</p>
                  <Card
                    sx={{
                      maxWidth: 281,
                      cursor: "pointer",
                      borderRadius: "10px",
                      overflow: "hidden",
                    }}
                    onClick={() => redirectToPage("pace")}
                  >
                    <CardMedia
                      component="img"
                      height="206"
                      image={GraphScreen}
                      alt="green iguana"
                    />
                  </Card>
                </>
              }
            </div>
          </ModalBody>
        </Box>
      </Modal>
    );
  }

  const redirectToPage = (redirectPath) => {
    if (redirectPath === "map") {
      navigate("/map"); // navigation
      subNavDataState.set("MAP"); // side nav
      sideDrawerActiveTabState.set(1); // for highlight
      mapSideNavTabState.set("Cars"); //Sub nav
      localStorage.setItem("mapSideNavTabState", "Cars");
    } else if (redirectPath === "actionzone") {
      navigate("/map");
      subNavDataState.set("MAP");
      sideDrawerActiveTabState.set(1);
      mapSideNavTabState.set("Action Zones"); //Sub nav
      localStorage.setItem("mapSideNavTabState", "Action Zones");
    } else if (redirectPath === "pins") {
      handleModalOpen(); //Sub nav
    } else if (redirectPath === "print") {
      navigate("/pins", { state: "color" });
      subNavDataState.set("PINS");
      sideDrawerActiveTabState.set(7);
      mapSideNavTabState.set("Pin Placement"); //Sub nav
      localStorage.setItem("mapSideNavTabState", "Pin Placement");
    } else if (redirectPath === "location") {
      navigate("/pins");
      subNavDataState.set("PINS");
      sideDrawerActiveTabState.set(7);
      mapSideNavTabState.set("Pin Placement"); //Sub nav
      localStorage.setItem("mapSideNavTabState", "Pin Placement");
      dispatch(setPinsEditModeReduxStateAction(true));
    } else if (redirectPath === "placement") {
      navigate("/pins");
      subNavDataState.set("PINS");
      sideDrawerActiveTabState.set(7);
      mapSideNavTabState.set("Pin Placement"); //Sub nav
      localStorage.setItem("mapSideNavTabState", "Pin Placement");
    } else if (redirectPath === "cars") {
      navigate("/fleet");
      sideDrawerActiveTabState.set(2);
      mapSideNavTabState.set("Cars");
      localStorage.setItem("mapSideNavTabState", "Cars");
      listBy.set("IN USE");
    } else if (redirectPath === "fcr") {
      navigate("/fleet");
      sideDrawerActiveTabState.set(2);
      subNavDataState.set("FLEET");
      localStorage.setItem("mapSideNavTabState", "Usage");
      mapSideNavTabState.set("Usage");
      holeStateGlobal.set(false);
      roundStateGlobal.set(true);
    } else if (redirectPath === "pace") {
      navigate("/pace", { state: "Current" });
      subNavDataState.set("PACE");
      sideDrawerActiveTabState.set(4);
      mapSideNavTabState.set("Current");
      localStorage.setItem("mapSideNavTabState", "Current");
    } else if (redirectPath === "pacereports") {
      navigate("/pace", { state: "Current" });
      subNavDataState.set("PACE");
      sideDrawerActiveTabState.set(4);
      mapSideNavTabState.set("Current");
      localStorage.setItem("mapSideNavTabState", "Current");
    } else if (redirectPath === "ampreports") {
      //ampreports
      navigate("/fleet", { state: "Usage" });
      subNavDataState.set("FLEET");
      sideDrawerActiveTabState.set(2);
      mapSideNavTabState.set("Usage");
      localStorage.setItem("mapSideNavTabState", "Usage");
    } else if (redirectPath === "pre-round") {
      navigate("/fleet");
      subNavDataState.set("FLEET");
      sideDrawerActiveTabState.set(2);
      mapSideNavTabState.set("Cars");
      localStorage.setItem("mapSideNavTabState", "Cars");
    } else if (redirectPath === "battery-notification") {
      navigate("/fleet");
      subNavDataState.set("FLEET");
      sideDrawerActiveTabState.set(2);
      mapSideNavTabState.set("Cars");
      localStorage.setItem("mapSideNavTabState", "Cars");
    } else if (redirectPath === "roundsCompleted") {
      navigate("/fleet");
      subNavDataState.set("FLEET");
      sideDrawerActiveTabState.set(2);
      mapSideNavTabState.set("Cars");
      localStorage.setItem("mapSideNavTabState", "Cars");
    } else if (redirectPath === "amp") {
      navigate("/fleet");
      subNavDataState.set("FLEET");
      sideDrawerActiveTabState.set(2);
      mapSideNavTabState.set("Usage");
      subNavDataState.set("PACE");
      sideDrawerActiveTabState.set(4);
      mapSideNavTabState.set("Pace");
      localStorage.setItem("mapSideNavTabState", "Pace");
    } else if (redirectPath === "ActionZoneAlertCount") {
      handleCarPathModalClose();
      handleGeofenceModalClose();
      handleAlertModalOpen();
    } else if (redirectPath === "CarsInCartPath") {
      handleAlertModalClose();
      handleGeofenceModalClose();
      handleCarPathModalOpen();
    } else if (redirectPath === "CarsInGeoFence") {
      handleAlertModalClose();
      handleCarPathModalClose();
      handleGeofenceModalOpen();
    } else if (redirectPath === "dashPace") {
      navigate("/pace");
      subNavDataState.set("PACE");
      sideDrawerActiveTabState.set(4);
      mapSideNavTabState.set("Current");
      localStorage.setItem("mapSideNavTabState", "Current");
    } else if (redirectPath === "dashpathRule") {
      navigate("/map");
      sideDrawerActiveTabState.set(1);
      subNavDataState.set("MAP");
      localStorage.setItem("activeMapSideNavTab", "CPO");
      localStorage.setItem("mapSideNavTabState", "CPO");
      mapSideNavTabState.set("CPO");
    } else if (redirectPath === "welcome") {
      navigate("/ads");
      sideDrawerActiveTabState.set(5);
      subNavDataState.set("ADS");
      localStorage.setItem("mapSideNavTabState", "Image Gallery");
      mapSideNavTabState.set("Image Gallery");
    } else if (redirectPath === "car-path") {
      navigate("/map");
      sideDrawerActiveTabState.set(1);
      subNavDataState.set("MAP");
      localStorage.setItem("activeMapSideNavTab", "CPO");
      localStorage.setItem("mapSideNavTabState", "CPO");
      mapSideNavTabState.set("CPO");
    } else if (redirectPath === "today-camp-ads") {
      navigate("/ads");
      sideDrawerActiveTabState.set(5);
      subNavDataState.set("ADS");
      localStorage.setItem("mapSideNavTabState", "Image Gallery");
      mapSideNavTabState.set("Image Gallery");
    } else if (redirectPath === "") {
      return;
    }
  };

  function handlerSaveLayout() {
    let featureLayout = {
      upperLayout: JSON.stringify(layoutPayload),
      middleLayout: JSON.stringify(middlelayoutPayload),
    };

    let featureSet = {
      fleetUtilization: FleetRoationCard,
      carBehind: CarsBehindPaceCard,
      todayPin: TodayPinPositionCard,
      roundCompleted: RoundCompletedCard,
      todayRound: TodayRoundsCard,
      chatCam: ChatCamCard,
      ghin: GhinCard,
      paceReport: paceReportCard,
      ampHr: ampHrCard,
      dashPace: PaceFastSlowestCard,
      readiness: FleetReadinessCard,
      carMovement: CarMovementCard,
      carRoundStatus: CarRoundStatusCard,
      welcome: WelcomeCard,
      welcomeInfo: WeatherCard,
      map: mapCard,
      carSelection: CarSelectionCard,
      carPath: TodayCartPathCard,
      batteryNotification: BatteryNotificationCard,
      actionzoneInfraction: ActionZoneCard,
      paceOfPlay: PacePlayReportCard,
      fleetUsageReport: FleetUsageReportCard,
      todayCampaign: TodayCampaignAdsCard,
    };
    let modifiedDate = moment(new Date()).utc().format();

    let payload = {
      Id: 0,
      UserId: 0,
      LastModifiedInUtc: modifiedDate,
      DashboardFeatures: JSON.stringify(featureSet),
      DashboardLayout: JSON.stringify(featureLayout),
      User: null,
    };

    setReloadDashState(false);
    setTriggerReload(false);
    setDetectSaveChanges(false);
    dispatch(COMMON_SERVICES.putDashboardFeatureSetServices(payload)).then(
      () => {
        setIsShown(false);
        if (siteId.get() !== null) {
          dispatch(COMMON_SERVICES.getDashboardFeatureSetServices());
        }
      }
    );
  }

  function toggleWidgetVisibility(widgetName) {
    switch (widgetName) {
      case "fleet-car":
        {
          setFleetRoationCard(!FleetRoationCard);
          setDetectSaveChanges(true);
        }

        break;
      case "car-movement":
        {
          setCarMovementCard(!CarMovementCard);
          setDetectSaveChanges(true);
        }
        break;
      case "car-behind":
        {
          setCarsBehindPaceCard(!CarsBehindPaceCard);
          setDetectSaveChanges(true);
        }
        break;
      case "dash-pace":
        {
          setPaceFastSlowestCard(!PaceFastSlowestCard);
          setDetectSaveChanges(true);
        }
        break;
      case "round-completed":
        {
          setRoundCompletedCard(!RoundCompletedCard);
          setDetectSaveChanges(true);
        }
        break;
      case "today-round":
        {
          setTodayRoundsCard(!TodayRoundsCard);
          setDetectSaveChanges(true);
        }
        break;
      case "today-pin":
        {
          setTodayPinPositionCard(!TodayPinPositionCard);
          setDetectSaveChanges(true);
        }
        break;
      case "readiness":
        {
          setFleetReadinessCard(!FleetReadinessCard);
          setDetectSaveChanges(true);
        }
        break;
      case "pace-report":
        {
          setPaceReportCard(!paceReportCard);
          setDetectSaveChanges(true);
        }
        break;
      case "amp-hr":
        {
          setAmpHrCard(!ampHrCard);
          setDetectSaveChanges(true);
        }
        break;
      default:
    }
  }

  function ContainerBox() {
    return (
      <SettingContainer>
        <div className="close-icon-wrapper">
          <Modal
            open={alertMsg.get()}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            maxWidth="sm"
          >
            <Box sx={style1}>
              <PopUpContainer>
                <h2>{t("Confirm")}</h2>
                <p>{t("Discard_changes")} ?</p>

                <div className="action-btn">
                  <button onClick={handleDiscardChanges} className="primary">
                    {t("Yes")}
                  </button>
                  <button
                    onClick={() => {
                      alertMsg.set(false);
                      setSaveModalState(false);
                    }}
                  >
                    {t("No")}
                  </button>
                </div>
              </PopUpContainer>
            </Box>
          </Modal>
          <button onClick={handleClick}>
            {t("Close")} <CloseIcon />
          </button>
        </div>
        <FilterContainer>
          <div>
            <h3>{t("Standard_Connectivity")}</h3>
            <button
              className={CarSelectionCard ? "selected" : ""}
              onClick={() => {
                setCarSelectionCard(!CarSelectionCard);
                setDetectSaveChanges(true);
              }}
            >
              <CarSelectionIcon />
              {t("Car_Selection")}
            </button>
            <button
              className={BatteryNotificationCard ? "selected" : ""}
              onClick={() => {
                setBatteryNotificationCard(!BatteryNotificationCard);
                setDetectSaveChanges(true);
              }}
            >
              <BatteryNotificationIcon />
              {t("Battery_Notification")}
            </button>
            {/* <button
              className={ServiceNotificationCard ? "selected" : null}
              onClick={() =>
                setServiceNotificationCard(!ServiceNotificationCard)
              }
            >
              <ServiceNotificationIcon />
              Service Notification
            </button> */}
          </div>
          <div>
            <h3 className="yellow-border">{t("Car_Tracking_and_POP")}</h3>
            <button
              className={
                FleetRoationCard &&
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().car_control
                  )
                  ? "selected"
                  : ""
              }
              disabled={getFeatureSetOption(
                siteSettingsData && siteSettingsData?.Features,
                getFeaturesList().car_control
              )}
              onClick={() => {
                toggleWidgetVisibility("fleet-car");
              }}
            >
              <CarSelectionIcon />
              {t("Fleet_Utilization")}
            </button>
            <button
              className={CarMovementCard ? "selected" : ""}
              onClick={() => {
                toggleWidgetVisibility("car-movement");
              }}
            >
              <CarMovementIcon />
              {t("Car_movement")}
            </button>
            <button
              className={
                CarsBehindPaceCard &&
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().real_time_tracking
                  )
                  ? "selected"
                  : ""
              }
              onClick={() => {
                toggleWidgetVisibility("car-behind");
              }}
              disabled={
                getFeatureSetOption(
                  siteSettingsData && siteSettingsData?.Features,
                  getFeaturesList().real_time_tracking
                ) &&
                getUserRole &&
                getUserRole.Role != 6
              }
            >
              <ServiceNotificationIcon />
              {t("Cars_Behind_Pace")}
            </button>

            <button
              className={
                PaceFastSlowestCard &&
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().real_time_tracking
                  )
                  ? "selected"
                  : ""
              }
              onClick={() => {
                setPaceFastSlowestCard(!PaceFastSlowestCard);
                setDetectSaveChanges(true);
              }}
              disabled={
                getFeatureSetOption(
                  siteSettingsData && siteSettingsData?.Features,
                  getFeaturesList().real_time_tracking
                ) &&
                getUserRole &&
                getUserRole.Role != 6
              }
            >
              <ServiceNotificationIcon />
              Pace: Fastest / Slowest
            </button>
            <button
              className={RoundCompletedCard ? "selected" : ""}
              onClick={() => {
                toggleWidgetVisibility("round-completed");
              }}
            >
              <ServiceNotificationIcon />
              Round Completed
            </button>
            <button
              className={
                paceReportCard &&
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().real_time_tracking
                  )
                  ? "selected"
                  : ""
              }
              onClick={() => {
                toggleWidgetVisibility("pace-report");
              }}
            >
              <ServiceNotificationIcon />
              {t("Current_Pace")}
            </button>
            <button
              className={ampHrCard ? "selected" : ""}
              onClick={() => {
                toggleWidgetVisibility("amp-hr");
              }}
            >
              <ServiceNotificationIcon />
              {t("AMP_HR_Report")}
            </button>
            <button
              className={FleetReadinessCard ? "selected" : ""}
              onClick={() => {
                setFleetReadinessCard(!FleetReadinessCard);
                setDetectSaveChanges(true);
              }}
            >
              <ServiceNotificationIcon />
              {t("Fleet_Readiness")}
            </button>
            <button
              className={
                TodayRoundsCard &&
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().real_time_tracking
                  )
                  ? "selected"
                  : ""
              }
              onClick={() => {
                toggleWidgetVisibility("today-round");
              }}
              disabled={
                getFeatureSetOption(
                  siteSettingsData && siteSettingsData?.Features,
                  getFeaturesList().real_time_tracking
                ) &&
                getUserRole &&
                getUserRole.Role != 6
              }
            >
              <ServiceNotificationIcon />
              {t("Todays_Rounds")}
            </button>
            {/* <button
              className={GapsFlowCard ? "selected" : null}
              onClick={() => {
                setGapsFlowCard(!GapsFlowCard);
                setDetectSaveChanges(true);
              }}
            >
              <GapsFlowIcon />
              Gaps in Flow
            </button> */}
            <button
              className={
                CarRoundStatusCard &&
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().real_time_tracking
                  )
                  ? "selected"
                  : ""
              }
              onClick={() => {
                setCarRoundStatusCard(!CarRoundStatusCard);
                setDetectSaveChanges(true);
              }}
              disabled={
                getFeatureSetOption(
                  siteSettingsData && siteSettingsData?.Features,
                  getFeaturesList().real_time_tracking
                ) &&
                getUserRole &&
                getUserRole.Role != 6
              }
            >
              <ServiceNotificationIcon />
              {t("Car_Round_Status")}
            </button>
          </div>
          <div>
            <h3 className="red-border">{t("Car_Control")}</h3>
            <button
              className={TodayCartPathCard ? "selected" : ""}
              onClick={() => {
                setTodayCartPathCard(!TodayCartPathCard);
                setDetectSaveChanges(true);
              }}
            >
              <CartPathSettingIcon />
              {t("Todays_Cart_Path_Rule")}
            </button>
            <button
              className={ActionZoneCard ? "selected" : ""}
              onClick={() => {
                setActionZoneCard(!ActionZoneCard);
                setDetectSaveChanges(true);
              }}
            >
              <ActionZoneIcon />
              {t("Action_Zone_Infraction")}
            </button>
            {/* <button
              className={FleetLockDownCard ? "selected" : null}
              onClick={() => setFleetLockDownCard(!FleetLockDownCard)}
              disabled={
                getFeatureSetOption(
                  siteSettingsData && siteSettingsData?.Features,
                  getFeaturesList().car_control
                ) &&
                getUserRole &&
                getUserRole.Role != 6
              }
            >
              <FleetLockIcon />
              Fleet Lock-Down
            </button> */}
          </div>
          <div>
            <h3 className="green-border">{t("Golfer_Experience")}</h3>
            <button
              className={
                TodayPinPositionCard &&
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().golfer_experience
                  )
                  ? "selected"
                  : ""
              }
              onClick={() => {
                toggleWidgetVisibility("today-pin");
              }}
              disabled={
                getFeatureSetOption(
                  siteSettingsData && siteSettingsData?.Features,
                  getFeaturesList().golfer_experience
                ) &&
                getUserRole &&
                getUserRole.Role != 6
              }
            >
              <CarMovementIcon />
              {t("Todays_Pin_Position")}
            </button>
            <button
              className={TodayCampaignAdsCard ? "selected" : ""}
              onClick={() => {
                setTodayCampaignAdsCard(!TodayCampaignAdsCard);
                setDetectSaveChanges(true);
              }}
            >
              <TodayCampaignIcon />
              {t("Todays_Campaign_Ads")}
            </button>
            <button
              className={WelcomeCard ? "selected" : ""}
              onClick={() => {
                setWelcomeCard(!WelcomeCard);
                setDetectSaveChanges(true);
              }}
            >
              <GapsFlowIcon />
              {t("Welcome_Screen")}
            </button>
            {/* <button
              className={FBSalesTotalCard ? "selected" : null}
              onClick={() => setFBSalesTotalCard(!FBSalesTotalCard)}
              disabled={
                getFeatureSetOption(
                  siteSettingsData && siteSettingsData?.Features,
                  getFeaturesList().golfer_experience
                ) &&
                getUserRole &&
                getUserRole.Role != 6
              }
            >
              <FBSaleIcon />
              F&B Sales - Total
            </button>
            <button
              className={FBSalesProductCard ? "selected" : null}
              onClick={() => setFBSalesProductCard(!FBSalesProductCard)}
              disabled={
                getFeatureSetOption(
                  siteSettingsData && siteSettingsData?.Features,
                  getFeaturesList().golfer_experience
                ) &&
                getUserRole &&
                getUserRole.Role != 6
              }
            >
              <FBSaleIcon />
              F&B Sales - Product Mix
            </button>
            <button
              className={WeatherCard ? "selected" : null}
              onClick={() => setWeatherCard(!WeatherCard)}
              disabled={
                getFeatureSetOption(
                  siteSettingsData && siteSettingsData?.Features,
                  getFeaturesList().real_time_tracking
                ) &&
                getUserRole &&
                getUserRole.Role != 6
              }
            >
              <FBSaleIcon />
              Weather
            </button>
            <button
              className={GhinCard ? "selected" : null}
              onClick={() => setGhinCard(!GhinCard)}
              disabled={
                getFeatureSetOption(
                  siteSettingsData && siteSettingsData?.Features,
                  getFeaturesList().golfer_experience
                ) &&
                getUserRole &&
                getUserRole.Role != 6
              }
            >
              <FBSaleIcon />
              GHIN
            </button>
            <button
              className={SurveyResultsCard ? "selected" : null}
              onClick={() => setSurveyResultsCard(!SurveyResultsCard)}
              disabled={
                getFeatureSetOption(
                  siteSettingsData && siteSettingsData?.Features,
                  getFeaturesList().real_time_tracking
                ) &&
                getUserRole &&
                getUserRole.Role != 6
              }
            >
              <FBSaleIcon />
              Survey Results
            </button>
            <button
              className={ScoreCardPostingCard ? "selected" : null}
              onClick={() => setScoreCardPostingCard(!ScoreCardPostingCard)}
              disabled={
                getFeatureSetOption(
                  siteSettingsData && siteSettingsData?.Features,
                  getFeaturesList().golfer_experience
                ) &&
                getUserRole &&
                getUserRole.Role != 6
              }
            >
              <FBSaleIcon />
              Scorecard posting
            </button>
            <button
              className={UpcomingEventCard ? "selected" : null}
              onClick={() => setUpcomingEventCard(!UpcomingEventCard)}
              disabled={
                getFeatureSetOption(
                  siteSettingsData && siteSettingsData?.Features,
                  getFeaturesList().golfer_experience
                ) &&
                getUserRole &&
                getUserRole.Role != 6
              }
            >
              <TodayCampaignIcon />
              Upcoming Events
            </button> */}
          </div>
          <div>
            <h3 className="brown-border">{t("Other")}</h3>
            {/* <button
              className={ChatCamCard ? "selected" : null}
              onClick={() => setChatCamCard(!ChatCamCard)}
            >
              <ChatIcon />
              Chat w/ CAM
            </button> */}
            <button
              className={
                PacePlayReportCard &&
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().real_time_tracking
                  )
                  ? "selected"
                  : ""
              }
              onClick={() => {
                setPacePlayReportCard(!PacePlayReportCard);
                setDetectSaveChanges(true);
              }}
              disabled={
                getFeatureSetOption(
                  siteSettingsData && siteSettingsData?.Features,
                  getFeaturesList().real_time_tracking
                ) &&
                getUserRole &&
                getUserRole.Role != 6
              }
            >
              <ActionZoneIcon />
              {t("Pace_of_Play_Reports")}
            </button>
            <button
              className={FleetUsageReportCard ? "selected" : ""}
              onClick={() => {
                setFleetUsageReportCard(!FleetUsageReportCard);
                setDetectSaveChanges(true);
              }}
            >
              <TodayCampaignIcon />
              {t("Fleet_Usage_Reports")}
            </button>
          </div>
        </FilterContainer>
        <div className="action-wrapper">
          <CircleBtn
            disabled={!detectSaveChanges}
            className={detectSaveChanges ? "active" : "disabled"}
            onClick={handlerSaveLayout}
          >
            {t("Save")}
          </CircleBtn>
          <CircleBtn
            onClick={() => {
              if (detectSaveChanges) {
                alertMsg.set(true);
                setSaveModalState(true);
              } else {
                setIsShown(false);
                setDetectSaveChanges(false);
              }
            }}
          >
            {t("Cancel")}
          </CircleBtn>
        </div>
      </SettingContainer>
    );
  }

  function paceString(car) {
    let result = "";
    if (car) {
      if (car?.Car?.Pace > 0)
        result = car?.Car?.Pace.toString() + " min ahead ";
      else if (car?.Car?.Pace < 0)
        result = (-car?.Car?.Pace).toString() + " min behind ";
      else result = "on pace ";
      if (car?.Car?.HolesPlayed > 0)
        result =
          result +
          "through " +
          car?.Car?.HolesPlayed.toString() +
          " hole" +
          (car?.Car?.HolesPlayed > 1 ? "s" : "");
    }
    return {
      result: result,
      carNum: car?.Car?.CarNumber,
    };
  }

  function carList() {
    return (
      carBehindPaceData &&
      carBehindPaceData.length > 0 &&
      carBehindPaceData?.map((car) => {
        return paceString(car);
      })
    );
  }

  const getLayouts = () => {
    if (
      getDashboardFeatureSetState &&
      getDashboardFeatureSetState !== undefined &&
      Object.keys(getDashboardFeatureSetState).length !== 0
    ) {
      let savedLayouts = JSON.parse(
        getDashboardFeatureSetState?.DashboardLayout
      );

      if (
        savedLayouts &&
        savedLayouts.length !== 0 &&
        savedLayouts !== null &&
        savedLayouts?.upperLayout !== undefined
      ) {
        if (detectSaveChanges) {
          return layoutPayload;
        } else {
          return JSON.parse(savedLayouts?.upperLayout);
        }
      }
    }

    return layout;
  };

  const getMiddleLayouts = () => {
    if (
      getDashboardFeatureSetState &&
      getDashboardFeatureSetState !== undefined &&
      Object.keys(getDashboardFeatureSetState).length !== 0
    ) {
      let savedLayouts = JSON.parse(
        getDashboardFeatureSetState?.DashboardLayout
      );

      if (
        savedLayouts &&
        savedLayouts.length !== 0 &&
        savedLayouts !== null &&
        savedLayouts?.middleLayout !== undefined
      ) {
        if (detectSaveChanges) {
          return middlelayoutPayload;
        } else {
          return JSON.parse(savedLayouts?.middleLayout);
        }
      }
    }

    return middleLayout;
  };

  if (
    getDashboardFeatureSetStatus === API_STATUSES.REQUEST ||
    siteId.get() === null
  ) {
    return <Loader />;
  }

  return (
    <>
      {modal()}
      {carBehindModal()}
      <Header>
        <div className="heading">
          <p>
            <span>{currentDate}</span> {localSiteTimeState.get()}
          </p>
        </div>
        <div className="role-wrapper">
          <FormControl>
            <Select
              native
              labelId="demo-controlled-open-select-label"
              id="demo-controlled-open-select"
              variant="outlined"
              value={localStorage.getItem("dashCourseId")}
              onChange={handleCourseName}
              IconComponent={() => (
                <div className="arrow-icon">
                  <SelectArrow />
                </div>
              )}
            >
              {courseList &&
                courseList?.Courses &&
                courseList?.Courses.length !== 0 ? (
                courseList?.Courses.map((item, index) => (
                  <option key={item?.Number} value={item?.Number}>
                    {item?.Name}
                  </option>
                ))
              ) : (
                <option value=""></option>
              )}
            </Select>
          </FormControl>
          <button onClick={handleClick}>
            <SettingsIcon />
          </button>
        </div>
        {isShown && <>{ContainerBox()}</>}
      </Header>

      <BodyWrapper>
        <TopRow>
          <ResponsiveGridLayout
            layouts={{ lg: getLayouts() }}
            breakpoints={{ lg: 1700, md: 1300, sm: 768, xs: 480 }}
            cols={{ lg: 6, md: 5, sm: 1, xs: 2, xxs: 1 }}
            rowHeight={300}
            width={1841}
            margin={[20, 20]}
            compactType="horizontal"
            isDraggable={true}
            isBounded={false}
            onLayoutChange={(newLayout) => handleLayoutChange(newLayout)}
            onDrag={() => setDragState(true)}
            onDragStop={(_, oldItem) => {
              if (dashDragState) {
                setDragState(false);
              }
              else {
                const item = showData.filter((i) => i.compKey === oldItem.i);
                Object.keys(item).length > 0 && typeof item[0]?.renderFunction === "string"
                  ? redirectToPage(item[0]?.renderFunction)
                  : item[0]?.renderFunction();
              }
            }}
          >
            {showData
              .filter((it) => {
                if (
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().real_time_tracking,
                    getFeaturesList().golfer_experience
                  ) &&
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().car_control
                  ) &&
                  getUserRole &&
                  getUserRole.Role != 6
                ) {
                  return it;
                } else if (
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().real_time_tracking
                  ) &&
                  getUserRole &&
                  getUserRole.Role != 6 &&
                  (it.compKey == "car-behind" ||
                    it.compKey == "today-round" ||
                    it.compKey == "pace-report" ||
                    it.compKey == "dash-pace")
                ) {
                  return it;
                } else if (
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().car_control
                  ) &&
                  getUserRole &&
                  getUserRole.Role != 6 &&
                  it.compKey == "fleet-car"
                ) {
                  return it;
                } else if (
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().golfer_experience
                  ) &&
                  getUserRole &&
                  getUserRole.Role != 6 &&
                  (it.compKey == "today-pin" || it.compKey == "ghin")
                ) {
                  return it;
                } else if (
                  it.compKey != "car-behind" &&
                  it.compKey != "today-pin" &&
                  it.compKey != "today-round" &&
                  it.compKey != "pace-report" &&
                  it.compKey != "ghin" &&
                  it.compKey != "dash-pace" &&
                  it.compKey != "fleet-car"
                ) {
                  return it;
                }
              })
              ?.map((d) => {
                return d?.condition ? (
                  <TopBox
                    key={d?.compKey}
                    className={d.classname ? d.classname : ""}
                  >
                    {d?.comp}
                  </TopBox>
                ) : (
                  <></>
                );
              })}
          </ResponsiveGridLayout>
        </TopRow>

        <TopRow>
          <ResponsiveGridLayout
            layouts={{ lg: getMiddleLayouts() }}
            breakpoints={{ lg: 1600, md: 1360, sm: 768, xs: 480 }}
            cols={{ lg: 4, md: 3, sm: 2, xs: 2, xxs: 1 }}
            rowHeight={400}
            width={1841}
            margin={[20, 20]}
            compactType="horizontal"
            isDraggable={true}
            isBounded={false}
            onLayoutChange={(newLayout) => handleMiddleLayoutChange(newLayout)}
            onDrag={() => setDragState(true)}
            onDragStop={(_, oldItem) => {
              if (dashDragState) {
                setDragState(false);
              }
              else {
                const item = showMiddleLayout.filter((i) => i.compKey === oldItem.i);
                Object.key(item).length > 0 && typeof item[0]?.renderFunction === "string"
                  ? redirectToPage(item[0]?.renderFunction)
                  : item[0]?.renderFunction();
              }
            }}
          >
            {showMiddleLayout
              .filter((it) => {
                if (
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().real_time_tracking,
                    getFeaturesList().golfer_experience
                  ) &&
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().car_control
                  ) &&
                  getUserRole &&
                  getUserRole.Role != 6
                ) {
                  return it;
                } else if (
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().real_time_tracking
                  ) &&
                  getUserRole &&
                  getUserRole.Role != 6 &&
                  (it.compKey == "car-behind" ||
                    it.compKey == "today-round" ||
                    it.compKey == "pace-report" ||
                    it.compKey == "dash-pace" ||
                    it.compKey == "car-round-status")
                ) {
                  return it;
                } else if (
                  !getFeatureSetOption(
                    siteSettingsData && siteSettingsData?.Features,
                    getFeaturesList().golfer_experience
                  ) &&
                  getUserRole &&
                  getUserRole.Role != 6 &&
                  (it.compKey == "today-pin" || it.compKey == "ghin")
                ) {
                  return it;
                } else if (
                  it.compKey != "car-behind" &&
                  it.compKey != "today-pin" &&
                  it.compKey != "today-round" &&
                  it.compKey != "pace-report" &&
                  it.compKey != "ghin" &&
                  it.compKey != "dash-pace" &&
                  it.compKey != "car-round-status"
                ) {
                  return it;
                }
              })
              ?.map((d) => {
                return d?.condition ? (
                  <TopBox
                    key={d?.compKey}
                    className={d.classname ? d.classname : ""}
                  >
                    {d?.comp}
                  </TopBox>
                ) : (
                  <></>
                );
              })}
          </ResponsiveGridLayout>
        </TopRow>

        {TodayCampaignAdsCard ? (
          <CampaignAdsSlider>
            <TopBox>
              <div
                className="header"
                onClick={() => redirectToPage("today-camp-ads")}
              >
                <CameraIcon />
                <p className="green-border">{t("Todays_Campaign_Ads")}</p>
              </div>
              <div className="slider-section">
                <CampaignAds />
              </div>
            </TopBox>
          </CampaignAdsSlider>
        ) : null}

        {/* <EventSurveySection>
          {UpcomingEventCard &&
          !getFeatureSetOption(
            siteSettingsData && siteSettingsData?.Features,
            getFeaturesList().golfer_experience
          ) &&
          getUserRole &&
          getUserRole.Role != 6 ? (
            <TopBox>
              <div className="header">
                <UpcomingEvents />
                <p className="green-border">Upcoming Events</p>
              </div>
              <div className="box-body upcoming-events ">
                <div>
                  <img src={DummyUpcomingEvent} alt="dummy" />
                </div>
              </div>
            </TopBox>
          ) : null}
          {SurveyResultsCard &&
          !getFeatureSetOption(
            siteSettingsData && siteSettingsData?.Features,
            getFeaturesList().real_time_tracking
          ) &&
          getUserRole &&
          getUserRole.Role != 6 ? (
            <TopBox>
              <div className="header">
                <SurveyResultIcon />
                <p className="green-border">Survey Result</p>
              </div>
            </TopBox>
          ) : null}
        </EventSurveySection> */}

        {/* <FBChartSection>
          {FBSalesTotalCard &&
          !getFeatureSetOption(
            siteSettingsData && siteSettingsData?.Features,
            getFeaturesList().golfer_experience
          ) &&
          getUserRole &&
          getUserRole.Role != 6 ? (
            <TopBox className="fleet-car-rotation">
              <div className="header">
                <FbIcon color="#666" />
                <p className="green-border">F&B Sales - Total</p>
              </div>
              <div className="box-body ">
                <img src={DummyFbChart} alt="dummy" />
              </div>
            </TopBox>
          ) : null}
          {FBSalesProductCard &&
          !getFeatureSetOption(
            siteSettingsData && siteSettingsData?.Features,
            getFeaturesList().golfer_experience
          ) &&
          getUserRole &&
          getUserRole.Role != 6 ? (
            <TopBox className="fleet-car-rotation">
              <div className="header">
                <FbIcon color="#666" />
                <p className="green-border">F&B Sales - Product Mix</p>
              </div>
              <div className="box-body" style={{ padding: "60px 38px 38px" }}>
                <img src={DummyFbProduct} alt="dummy" />
              </div>
            </TopBox>
          ) : null}
        </FBChartSection> */}

        <PaceFleetChartSection>
          {PacePlayReportCard &&
            !getFeatureSetOption(
              siteSettingsData && siteSettingsData?.Features,
              getFeaturesList().real_time_tracking
            ) &&
            getUserRole &&
            getUserRole.Role != 6 ? (
            <TopBox
              onClick={() => redirectToPage("pace")}
              className="fleet-car-rotation"
            >
              <PaceOfPlay />
            </TopBox>
          ) : null}
          {FleetUsageReportCard ? (
            <TopBox
              onClick={() => redirectToPage("fcr")}
              className="fleet-car-rotation"
            >
              <FleetUsageReports />
            </TopBox>
          ) : null}
        </PaceFleetChartSection>
      </BodyWrapper>
    </>
  );
};
